import { render, staticRenderFns } from "./remit.vue?vue&type=template&id=6177e2c7&scoped=true"
import script from "./remit.vue?vue&type=script&lang=js"
export * from "./remit.vue?vue&type=script&lang=js"
import style0 from "./remit.vue?vue&type=style&index=0&id=6177e2c7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6177e2c7",
  null
  
)

export default component.exports